import React, { useContext } from "react";
import LineStyleIcon from "@mui/icons-material/LineStyle";
import { Link, useLocation } from "react-router-dom";
import "./sidebar.css";
import AuthContext from "../../../contexts/Islogin";

export default function Sidebar() {
  const location = useLocation();
  const { url, LoginUser } = useContext(AuthContext);
  console.log('loginUser', LoginUser, url);

  const links = [
    { path: "/wallet", label: "ایجاد کیف پول" },
    { path: "/withdraw/usdt", label: "دریافت کیف پول" },
    { path: "/withdraw/batch/usdt", label: "اعتبار سنجی کیف پول" },
    { path: "/withdraw/trx", label: "برداشت" },
    { path: "/verify/deposit", label: "تراکنش ها" },
  ];

  // 👇 فقط وقتی id برابر 1 یا 2 باشه این آیتم اضافه میشه
  if (LoginUser?.id === 1 || LoginUser?.id === 2) {
    links.push({
      path: "/verify/address/آدرس-مثال",
      label: "تایید پرداخت ها"
    });
  }

  return (
    <div className="sidebar">
      <div className="sidebar-wrapper">
        <div className="sidebar-menu">
          <h3 className="title">TronVault API Test</h3>
          <ul className="sidebar-list">
            {links.map((item, index) => (
              <Link className="link" to={item.path} key={index}>
                <li
                  className={
                    location.pathname === item.path
                      ? "sidebar-icon active"
                      : "sidebar-icon"
                  }
                >
                  <LineStyleIcon className="icon" />
                  {item.label}
                </li>
              </Link>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
